module.exports = __webpack_public_path__ + "assets/line.d8ffa0fa.svg";